// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Modal__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Modal/Modal.scss
 ** module id = 923
 ** module chunks = 1
 **/